import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const TeamMemberDialogContentWrapper: StyleRule = ({ theme }) => ({
    height: 'auto',
    overflowX: 'hidden',
    overflowY: 'auto',
    border: 'none !important',
    margin: '0 !important',
    paddingTop: pxToRem(75),
    [theme.screen.tablet]: {
        padding: pxToRem(0),
    },
});
